import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ChangeAnnotationFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeAnnotationFilter';

    public constructor(public annotationId: string) {
        super(ChangeAnnotationFilter.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ChangeAnnotationFilter): void => {
    if (state.filterState.annotationIds.includes(action.annotationId)) {
        state.filterState.annotationIds = state.filterState.annotationIds.filter((x) => x !== action.annotationId);
    } else {
        state.filterState.annotationIds.push(action.annotationId);
    }
};

//@ts-ignore
registerReducer(ChangeAnnotationFilter.ACTION_TYPE, reducer);